import { types as users } from '../actions/users'
import { types as sites } from '../actions/sites'
import { types as auth } from '../actions/auth'

const initialState = {}

const updateContent = (state, {role, user}) => {
  const arr = state[role.id] || []
  const index = arr.findIndex(c => c.id === user.id)
  const nextArr = index > -1
    ? [...arr.slice(0, index), user, ...arr.slice(index + 1)]
    : [...arr, user]

  return {[role.id]: nextArr}
}

const removeContent = (state, {role, user}) => {
  const arr = state[role.id] || []
  const index = arr.findIndex(c => c.id === user.id)

  return {[role.id]: [
    ...arr.slice(0, index),
    ...arr.slice(index + 1)
  ]}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case users.LOAD:
      return {...state,
        [action.data.role.id]: action.data.users
      }

    case users.SAVE:
      return {...state,
        ...updateContent(state, action.data)
      }

    case users.DELETE:
      return {...state,
        ...removeContent(state, action.data)
      }

    case sites.CHANGE:
    case auth.FAIL:
    case auth.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./app/reducers/users.js